import {Dialog, DialogActions, DialogContent, Box} from "@mui/material";
import { useState, useEffect } from "react";
import SearchingMsg from './SearchingMsg';
import Pjdb1Button from "./inputs/Pjdb1Button";

export interface DetailDialogProps {
  open: boolean,
  onClose: () => void,
  title: string,
  src: string,
}

export function DetailDialog(props: DetailDialogProps) {
  const [loading, setLoading] = useState(true);
  useEffect(()=>{
    setLoading(true);
  },[props.open]);

  return (
    <Dialog disableEscapeKeyDown open={props.open} onClose={props.onClose} maxWidth='xl' fullWidth>
      <DialogContent sx={{height: '80vh', overflow: 'hidden'}}>

        <iframe src={props.src} title={props.title} width='100%' height='100%'
          style={{ border:"none" }} onLoad={() => setLoading(false)} />

        { loading &&
          <Box display="flex" justifyContent="center" alignItems="center"
            width="100%" height="100%" sx={{position:"absolute",top:0,left:0,backgroundColor:"rgba(255, 255, 255, .6)"}}>
            <SearchingMsg />
          </Box>
        }

      </DialogContent>
      <DialogActions>
        <Pjdb1Button label="閉じる" color='inherit' variant='contained' onClick={props.onClose}/>
      </DialogActions>
    </Dialog>
  )
}
